import { gql } from '@apollo/client'

const GET_BENCHMARK_RECOMMENDED_STEP_DATA = gql`
  query BenchmarkRecommendedStepData {
    currentUser {
      attributes {
        ... on Coach {
          preferences {
            leadAutoReplyEnabled
          }
        }
      }
      groupEvents {
        id
        isCanceled
      }
    }
    lessonTypes {
      id
      category
      lessonPacks {
        id
      }
    }
    coachAvailabilities {
      id
      timeSlots {
        day
      }
    }
    coachingInquiries {
      contactMethod
    }
  }
`

export default GET_BENCHMARK_RECOMMENDED_STEP_DATA
